// extracted by mini-css-extract-plugin
export default {"martyBattContainer":"styles_martyBattContainer__5qrJ1","martyBattPercentage":"styles_martyBattPercentage__18WFq"};